import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BUI_ICON_TYPE_MAT, BuiIcon } from '@base/utils/icon-types.util';

@Component({
  selector: 'app-bui-drag-handle',
  templateUrl: './bui-drag-handle.component.html',
  styleUrls: ['./bui-drag-handle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BuiDragHandleComponent {
  @Input() isDisabled = false;
  @Input() iconSize: 'tiny' | 'small' | 'normal' = 'normal';
  @Input() iconColor: 'normal' | 'weak' | 'inverted' | 'primary' | 'accent' = 'normal';
  iconType: BuiIcon = BUI_ICON_TYPE_MAT;
}
